import { Redirect } from "expo-router"
import { EnsureLaunchDarklyInitialized } from "@/components/EnsureLaunchDarklyInitialized"
import { clearPreQualState } from "@/stores/preQual"
import { createVariantUsedEvent } from "@/analytics/events/launchdarkly"

const PreQualContent = () => {
  clearPreQualState()
  createVariantUsedEvent({ flag: "single-page-on-prequal", value: true })

  return <Redirect href={"/pre-qual/questions"} />
}

export default function PreQualIndex() {
  return (
    <EnsureLaunchDarklyInitialized>
      <PreQualContent />
    </EnsureLaunchDarklyInitialized>
  )
}
